import React from 'react';
import { FadeIn } from './FadeIn';
import { Card, CardContent, CardHeader, CardTitle } from './Card';
import { Cloud, BookOpen, ListTodo, MoonStar } from 'lucide-react';
export function FailedSolutionsSection() {
  const solutions = [{
    title: 'La Meditación Forzada',
    description: "Intentar observar tus pensamientos como 'nubes' requiere una energía mental que no tienes a medianoche.",
    icon: Cloud,
    color: 'text-sky-400'
  }, {
    title: 'El Journaling Libre',
    description: 'Escribir sin estructura a menudo te enreda más en tus propios dramas y te activa emocionalmente.',
    icon: BookOpen,
    color: 'text-emerald-400'
  }, {
    title: 'Las Listas de Tareas Comunes',
    description: 'Solo sirven para recordarte cuánto trabajo tienes, aumentando la presión en lugar de aliviarla.',
    icon: ListTodo,
    color: 'text-rose-400'
  }, {
    title: "El 'Contar Ovejas'",
    description: 'Es una distracción débil para un cerebro que detecta una amenaza real de incumplimiento.',
    icon: MoonStar,
    color: 'text-amber-400'
  }];
  return <section className="py-24 bg-stone-900 px-4 sm:px-6 lg:px-8" data-id="element-47">
      <div className="max-w-5xl mx-auto" data-id="element-48">
        <FadeIn className="text-center mb-16" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-50">
            Por qué lo que intentaste no funcionó
          </h2>
          <p className="text-xl text-stone-400 max-w-2xl mx-auto" data-id="element-51">
            Las soluciones tradicionales ignoran la biología de la ansiedad
            nocturna.
          </p>
        </FadeIn>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-52">
          {solutions.map((solution, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-53">
              <Card className="bg-stone-950/50 border-stone-800 h-full hover:border-stone-700 transition-colors" data-id="element-54">
                <CardHeader data-id="element-55">
                  <div className="w-12 h-12 rounded-lg bg-stone-900 flex items-center justify-center mb-4 border border-stone-800" data-id="element-56">
                    <solution.icon className={`w-6 h-6 ${solution.color}`} data-id="element-57" />
                  </div>
                  <CardTitle className="text-xl text-white" data-id="element-58">
                    {solution.title}
                  </CardTitle>
                </CardHeader>
                <CardContent data-id="element-59">
                  <p className="text-stone-400 leading-relaxed" data-id="element-60">
                    {solution.description}
                  </p>
                </CardContent>
              </Card>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}